import { History } from 'lucide-react';
import { formatDateTime } from '@/lib/format';
import { useT } from '@/lib/i18n';
import { useDocumentActivity } from '@/lib/sales';

/** The document's history (created, approved, edited, sent, voided) from the audit log. */
export function DocumentActivity({ id }: { id: string }) {
  const activity = useDocumentActivity(id);
  const t = useT();
  if (!activity.data?.length) return null;
  return (
    <section className="rounded-lg border bg-card p-4" data-testid="document-activity">
      <h2 className="mb-3 flex items-center gap-2 text-sm font-semibold">
        <History className="size-4 text-muted-foreground" aria-hidden />{' '}
        {t('salesPages.document.activity')}
      </h2>
      <ol className="flex flex-col gap-2 text-sm">
        {activity.data.map((e) => (
          <li key={e.id} className="grid grid-cols-[150px_1fr] gap-4">
            <span className="tnum text-muted-foreground">{formatDateTime(e.at)}</span>
            <span>
              <span className="font-medium">{e.label}</span>
              {e.detail ? <span className="text-muted-foreground"> · {e.detail}</span> : null}
              {e.by ? <span className="text-muted-foreground"> · {e.by}</span> : null}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
